window.addEventListener('load', function() {

    $(document).ready(function() {
        $('input[name="properties[Kişiselleştirme Yazısı]"]').on('input change blur', function() {
            var hasText = $(this).val().trim().length > 0;
            var $checkboxYazi = $('.pplr-checkbox-item[data-value*="Yazı Nakış ("]');
            
            if (hasText && !$checkboxYazi.is(':checked')) {
                $checkboxYazi.click();
            } else if (!hasText && $checkboxYazi.is(':checked')) {
                $checkboxYazi.click();
            }
        });
        
        $('input[name="properties[Logo]"]').on('change', function() {
            if (this.files && this.files.length > 0) {
                var $checkboxLogo = $('.pplr-checkbox-item[data-value*="Logo Nakış ("]');
                
                if (!$checkboxLogo.is(':checked')) {
                    setTimeout(function() {
                        $checkboxLogo.click();
                        console.log('Logo Nakış otomatik seçildi');
                    }, 300);
                }
            }
        });
    });


});


